// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file notifications/v2/notifications.proto (package notifications.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { Duration, DurationJson, StructJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file notifications/v2/notifications.proto.
 */
export const file_notifications_v2_notifications: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_google_protobuf_duration, file_google_protobuf_struct],
	);

/**
 * @generated from message notifications.v2.EmailActor
 */
export type EmailActor = Message<"notifications.v2.EmailActor"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;
};

/**
 * @generated from message notifications.v2.EmailActor
 */
export type EmailActorJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;
};

/**
 * Describes the message notifications.v2.EmailActor.
 * Use `create(EmailActorSchema)` to create a new message.
 */
export const EmailActorSchema: GenMessage<EmailActor, { jsonType: EmailActorJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 0);

/**
 * @generated from message notifications.v2.Attachment
 */
export type Attachment = Message<"notifications.v2.Attachment"> & {
	/**
	 * @generated from oneof notifications.v2.Attachment.file
	 */
	file:
		| {
				/**
				 * @generated from field: notifications.v2.S3Object s3 = 1;
				 */
				value: S3Object;
				case: "s3";
		  }
		| {
				/**
				 * @generated from field: notifications.v2.RawAttachment raw = 2;
				 */
				value: RawAttachment;
				case: "raw";
		  }
		| {
				/**
				 * @generated from field: string url = 4;
				 */
				value: string;
				case: "url";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;
};

/**
 * @generated from message notifications.v2.Attachment
 */
export type AttachmentJson = {
	/**
	 * @generated from field: notifications.v2.S3Object s3 = 1;
	 */
	s3?: S3ObjectJson;

	/**
	 * @generated from field: notifications.v2.RawAttachment raw = 2;
	 */
	raw?: RawAttachmentJson;

	/**
	 * @generated from field: string url = 4;
	 */
	url?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;
};

/**
 * Describes the message notifications.v2.Attachment.
 * Use `create(AttachmentSchema)` to create a new message.
 */
export const AttachmentSchema: GenMessage<Attachment, { jsonType: AttachmentJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 1);

/**
 * @generated from message notifications.v2.S3Object
 */
export type S3Object = Message<"notifications.v2.S3Object"> & {
	/**
	 * @generated from field: string bucket = 1;
	 */
	bucket: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;
};

/**
 * @generated from message notifications.v2.S3Object
 */
export type S3ObjectJson = {
	/**
	 * @generated from field: string bucket = 1;
	 */
	bucket?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;
};

/**
 * Describes the message notifications.v2.S3Object.
 * Use `create(S3ObjectSchema)` to create a new message.
 */
export const S3ObjectSchema: GenMessage<S3Object, { jsonType: S3ObjectJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 2);

/**
 * @generated from message notifications.v2.RawAttachment
 */
export type RawAttachment = Message<"notifications.v2.RawAttachment"> & {
	/**
	 * Base64 encoded file content
	 *
	 * @generated from field: string content = 1;
	 */
	content: string;

	/**
	 * file mimetype
	 *
	 * @generated from field: string content_type = 2;
	 */
	contentType: string;
};

/**
 * @generated from message notifications.v2.RawAttachment
 */
export type RawAttachmentJson = {
	/**
	 * Base64 encoded file content
	 *
	 * @generated from field: string content = 1;
	 */
	content?: string;

	/**
	 * file mimetype
	 *
	 * @generated from field: string content_type = 2;
	 */
	contentType?: string;
};

/**
 * Describes the message notifications.v2.RawAttachment.
 * Use `create(RawAttachmentSchema)` to create a new message.
 */
export const RawAttachmentSchema: GenMessage<RawAttachment, { jsonType: RawAttachmentJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 3);

/**
 * @generated from message notifications.v2.SenderIdentity
 */
export type SenderIdentity = Message<"notifications.v2.SenderIdentity"> & {
	/**
	 * Must be a verified domain
	 *
	 * @generated from field: notifications.v2.EmailActor from = 1;
	 */
	from?: EmailActor | undefined;

	/**
	 * @generated from field: notifications.v2.EmailActor reply_to = 2;
	 */
	replyTo?: EmailActor | undefined;

	/**
	 * @generated from field: string ip_group_id = 3;
	 */
	ipGroupId: string;
};

/**
 * @generated from message notifications.v2.SenderIdentity
 */
export type SenderIdentityJson = {
	/**
	 * Must be a verified domain
	 *
	 * @generated from field: notifications.v2.EmailActor from = 1;
	 */
	from?: EmailActorJson;

	/**
	 * @generated from field: notifications.v2.EmailActor reply_to = 2;
	 */
	replyTo?: EmailActorJson;

	/**
	 * @generated from field: string ip_group_id = 3;
	 */
	ipGroupId?: string;
};

/**
 * Describes the message notifications.v2.SenderIdentity.
 * Use `create(SenderIdentitySchema)` to create a new message.
 */
export const SenderIdentitySchema: GenMessage<SenderIdentity, { jsonType: SenderIdentityJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 4);

/**
 * @generated from message notifications.v2.DynamicTemplate
 */
export type DynamicTemplate = Message<"notifications.v2.DynamicTemplate"> & {
	/**
	 * @generated from field: notifications.v2.EmailTemplateType template_type = 4;
	 */
	templateType: EmailTemplateType;

	/**
	 * @generated from field: string template_id = 5;
	 */
	templateId: string;
};

/**
 * @generated from message notifications.v2.DynamicTemplate
 */
export type DynamicTemplateJson = {
	/**
	 * @generated from field: notifications.v2.EmailTemplateType template_type = 4;
	 */
	templateType?: EmailTemplateTypeJson;

	/**
	 * @generated from field: string template_id = 5;
	 */
	templateId?: string;
};

/**
 * Describes the message notifications.v2.DynamicTemplate.
 * Use `create(DynamicTemplateSchema)` to create a new message.
 */
export const DynamicTemplateSchema: GenMessage<DynamicTemplate, { jsonType: DynamicTemplateJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 5);

/**
 * @generated from message notifications.v2.EmailConfig
 */
export type EmailConfig = Message<"notifications.v2.EmailConfig"> & {
	/**
	 * @generated from field: notifications.v2.SenderIdentity sender = 1;
	 */
	sender?: SenderIdentity | undefined;

	/**
	 * @generated from field: repeated notifications.v2.EmailActor recipients = 2;
	 */
	recipients: EmailActor[];

	/**
	 * @generated from field: string subject = 3;
	 */
	subject: string;

	/**
	 * @generated from oneof notifications.v2.EmailConfig.template
	 */
	template:
		| {
				/**
				 * @generated from field: notifications.v2.DynamicTemplate dynamic_template = 4;
				 */
				value: DynamicTemplate;
				case: "dynamicTemplate";
		  }
		| {
				/**
				 * @generated from field: string raw_content = 5;
				 */
				value: string;
				case: "rawContent";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: repeated notifications.v2.Attachment attachments = 6;
	 */
	attachments: Attachment[];

	/**
	 * @generated from field: google.protobuf.Duration delay = 7;
	 */
	delay?: Duration | undefined;

	/**
	 * @generated from field: int64 suppression_group_id = 8;
	 */
	suppressionGroupId: bigint;

	/**
	 * @generated from field: repeated notifications.v2.EmailActor ccs = 9;
	 */
	ccs: EmailActor[];

	/**
	 * @generated from field: repeated notifications.v2.EmailActor bccs = 10;
	 */
	bccs: EmailActor[];
};

/**
 * @generated from message notifications.v2.EmailConfig
 */
export type EmailConfigJson = {
	/**
	 * @generated from field: notifications.v2.SenderIdentity sender = 1;
	 */
	sender?: SenderIdentityJson;

	/**
	 * @generated from field: repeated notifications.v2.EmailActor recipients = 2;
	 */
	recipients?: EmailActorJson[];

	/**
	 * @generated from field: string subject = 3;
	 */
	subject?: string;

	/**
	 * @generated from field: notifications.v2.DynamicTemplate dynamic_template = 4;
	 */
	dynamicTemplate?: DynamicTemplateJson;

	/**
	 * @generated from field: string raw_content = 5;
	 */
	rawContent?: string;

	/**
	 * @generated from field: repeated notifications.v2.Attachment attachments = 6;
	 */
	attachments?: AttachmentJson[];

	/**
	 * @generated from field: google.protobuf.Duration delay = 7;
	 */
	delay?: DurationJson;

	/**
	 * @generated from field: int64 suppression_group_id = 8;
	 */
	suppressionGroupId?: string;

	/**
	 * @generated from field: repeated notifications.v2.EmailActor ccs = 9;
	 */
	ccs?: EmailActorJson[];

	/**
	 * @generated from field: repeated notifications.v2.EmailActor bccs = 10;
	 */
	bccs?: EmailActorJson[];
};

/**
 * Describes the message notifications.v2.EmailConfig.
 * Use `create(EmailConfigSchema)` to create a new message.
 */
export const EmailConfigSchema: GenMessage<EmailConfig, { jsonType: EmailConfigJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 6);

/**
 * @generated from message notifications.v2.SMSConfig
 */
export type SMSConfig = Message<"notifications.v2.SMSConfig"> & {
	/**
	 * @generated from field: string sender = 1;
	 */
	sender: string;

	/**
	 * @generated from field: repeated string recipients = 2;
	 */
	recipients: string[];

	/**
	 * @generated from oneof notifications.v2.SMSConfig.template
	 */
	template:
		| {
				/**
				 * @generated from field: notifications.v2.DynamicTemplate dynamic_template = 3;
				 */
				value: DynamicTemplate;
				case: "dynamicTemplate";
		  }
		| {
				/**
				 * @generated from field: string raw_content = 4;
				 */
				value: string;
				case: "rawContent";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: repeated notifications.v2.Attachment attachments = 5;
	 */
	attachments: Attachment[];

	/**
	 * @generated from field: google.protobuf.Duration delay = 6;
	 */
	delay?: Duration | undefined;
};

/**
 * @generated from message notifications.v2.SMSConfig
 */
export type SMSConfigJson = {
	/**
	 * @generated from field: string sender = 1;
	 */
	sender?: string;

	/**
	 * @generated from field: repeated string recipients = 2;
	 */
	recipients?: string[];

	/**
	 * @generated from field: notifications.v2.DynamicTemplate dynamic_template = 3;
	 */
	dynamicTemplate?: DynamicTemplateJson;

	/**
	 * @generated from field: string raw_content = 4;
	 */
	rawContent?: string;

	/**
	 * @generated from field: repeated notifications.v2.Attachment attachments = 5;
	 */
	attachments?: AttachmentJson[];

	/**
	 * @generated from field: google.protobuf.Duration delay = 6;
	 */
	delay?: DurationJson;
};

/**
 * Describes the message notifications.v2.SMSConfig.
 * Use `create(SMSConfigSchema)` to create a new message.
 */
export const SMSConfigSchema: GenMessage<SMSConfig, { jsonType: SMSConfigJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 7);

/**
 * @generated from message notifications.v2.Notification
 */
export type Notification = Message<"notifications.v2.Notification"> & {
	/**
	 * @generated from oneof notifications.v2.Notification.config
	 */
	config:
		| {
				/**
				 * @generated from field: notifications.v2.EmailConfig email = 1;
				 */
				value: EmailConfig;
				case: "email";
		  }
		| {
				/**
				 * @generated from field: notifications.v2.SMSConfig sms = 3;
				 */
				value: SMSConfig;
				case: "sms";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: google.protobuf.Struct variables = 2;
	 */
	variables?: JsonObject | undefined;
};

/**
 * @generated from message notifications.v2.Notification
 */
export type NotificationJson = {
	/**
	 * @generated from field: notifications.v2.EmailConfig email = 1;
	 */
	email?: EmailConfigJson;

	/**
	 * @generated from field: notifications.v2.SMSConfig sms = 3;
	 */
	sms?: SMSConfigJson;

	/**
	 * @generated from field: google.protobuf.Struct variables = 2;
	 */
	variables?: StructJson;
};

/**
 * Describes the message notifications.v2.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification, { jsonType: NotificationJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 8);

/**
 * @generated from message notifications.v2.NotifyRequest
 */
export type NotifyRequest = Message<"notifications.v2.NotifyRequest"> & {
	/**
	 * @generated from field: notifications.v2.Notification notification = 1;
	 */
	notification?: Notification | undefined;
};

/**
 * @generated from message notifications.v2.NotifyRequest
 */
export type NotifyRequestJson = {
	/**
	 * @generated from field: notifications.v2.Notification notification = 1;
	 */
	notification?: NotificationJson;
};

/**
 * Describes the message notifications.v2.NotifyRequest.
 * Use `create(NotifyRequestSchema)` to create a new message.
 */
export const NotifyRequestSchema: GenMessage<NotifyRequest, { jsonType: NotifyRequestJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 9);

/**
 * @generated from message notifications.v2.NotifyResponse
 */
export type NotifyResponse = Message<"notifications.v2.NotifyResponse"> & {};

/**
 * @generated from message notifications.v2.NotifyResponse
 */
export type NotifyResponseJson = {};

/**
 * Describes the message notifications.v2.NotifyResponse.
 * Use `create(NotifyResponseSchema)` to create a new message.
 */
export const NotifyResponseSchema: GenMessage<NotifyResponse, { jsonType: NotifyResponseJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 10);

/**
 * @generated from message notifications.v2.TestNotifyRequest
 */
export type TestNotifyRequest = Message<"notifications.v2.TestNotifyRequest"> & {
	/**
	 * @generated from field: notifications.v2.Notification notification = 1;
	 */
	notification?: Notification | undefined;
};

/**
 * @generated from message notifications.v2.TestNotifyRequest
 */
export type TestNotifyRequestJson = {
	/**
	 * @generated from field: notifications.v2.Notification notification = 1;
	 */
	notification?: NotificationJson;
};

/**
 * Describes the message notifications.v2.TestNotifyRequest.
 * Use `create(TestNotifyRequestSchema)` to create a new message.
 */
export const TestNotifyRequestSchema: GenMessage<TestNotifyRequest, { jsonType: TestNotifyRequestJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 11);

/**
 * @generated from message notifications.v2.TestNotifyResponse
 */
export type TestNotifyResponse = Message<"notifications.v2.TestNotifyResponse"> & {};

/**
 * @generated from message notifications.v2.TestNotifyResponse
 */
export type TestNotifyResponseJson = {};

/**
 * Describes the message notifications.v2.TestNotifyResponse.
 * Use `create(TestNotifyResponseSchema)` to create a new message.
 */
export const TestNotifyResponseSchema: GenMessage<TestNotifyResponse, { jsonType: TestNotifyResponseJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 12);

/**
 * @generated from message notifications.v2.BatchNotifyRequest
 */
export type BatchNotifyRequest = Message<"notifications.v2.BatchNotifyRequest"> & {
	/**
	 * @generated from field: repeated notifications.v2.NotifyRequest requests = 1;
	 */
	requests: NotifyRequest[];
};

/**
 * @generated from message notifications.v2.BatchNotifyRequest
 */
export type BatchNotifyRequestJson = {
	/**
	 * @generated from field: repeated notifications.v2.NotifyRequest requests = 1;
	 */
	requests?: NotifyRequestJson[];
};

/**
 * Describes the message notifications.v2.BatchNotifyRequest.
 * Use `create(BatchNotifyRequestSchema)` to create a new message.
 */
export const BatchNotifyRequestSchema: GenMessage<BatchNotifyRequest, { jsonType: BatchNotifyRequestJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 13);

/**
 * @generated from message notifications.v2.BatchNotifyResponse
 */
export type BatchNotifyResponse = Message<"notifications.v2.BatchNotifyResponse"> & {};

/**
 * @generated from message notifications.v2.BatchNotifyResponse
 */
export type BatchNotifyResponseJson = {};

/**
 * Describes the message notifications.v2.BatchNotifyResponse.
 * Use `create(BatchNotifyResponseSchema)` to create a new message.
 */
export const BatchNotifyResponseSchema: GenMessage<BatchNotifyResponse, { jsonType: BatchNotifyResponseJson }> = /*@__PURE__*/ messageDesc(file_notifications_v2_notifications, 14);

/**
 * @generated from enum notifications.v2.EmailTemplateType
 */
export enum EmailTemplateType {
	/**
	 * @generated from enum value: EMAIL_TEMPLATE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: EMAIL_TEMPLATE_TYPE_SENDGRID = 1;
	 */
	SENDGRID = 1,

	/**
	 * @generated from enum value: EMAIL_TEMPLATE_TYPE_USER_DEFINED = 2;
	 */
	USER_DEFINED = 2,
}

/**
 * @generated from enum notifications.v2.EmailTemplateType
 */
export type EmailTemplateTypeJson = "EMAIL_TEMPLATE_TYPE_UNSPECIFIED" | "EMAIL_TEMPLATE_TYPE_SENDGRID" | "EMAIL_TEMPLATE_TYPE_USER_DEFINED";

/**
 * Describes the enum notifications.v2.EmailTemplateType.
 */
export const EmailTemplateTypeSchema: GenEnum<EmailTemplateType, EmailTemplateTypeJson> = /*@__PURE__*/ enumDesc(file_notifications_v2_notifications, 0);

/**
 * @generated from service notifications.v2.NotificationService
 */
export const NotificationService: GenService<{
	/**
	 * @generated from rpc notifications.v2.NotificationService.Notify
	 */
	notify: {
		methodKind: "unary";
		input: typeof NotifyRequestSchema;
		output: typeof NotifyResponseSchema;
	};
	/**
	 * Used to send a test notification to the caller's identity
	 *
	 * @generated from rpc notifications.v2.NotificationService.TestNotify
	 */
	testNotify: {
		methodKind: "unary";
		input: typeof TestNotifyRequestSchema;
		output: typeof TestNotifyResponseSchema;
	};
	/**
	 * @generated from rpc notifications.v2.NotificationService.BatchNotify
	 */
	batchNotify: {
		methodKind: "unary";
		input: typeof BatchNotifyRequestSchema;
		output: typeof BatchNotifyResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_notifications_v2_notifications, 0);
